module.exports = __webpack_public_path__ + "img/wanbao.87b47aa4.png";